import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { FeatureModel } from '../../interfaces/feature';
import { ThemeCard } from '../../theme/components/Card';
import { ThemeInput } from '../../theme/components/Input';
import { ThemeTextArea } from '../../theme/components/TextArea';
import { theme } from '../../theme/theme';

export interface FeatureProps {
  feature?: FeatureModel;
  onChange: (feature: FeatureModel) => void;
}

export const Feature: React.FC<FeatureProps> = ({ feature, onChange }) => {
  const [name, setName] = useState<string>(feature?.name ?? '');
  const [description, setDescription] = useState<string>(feature?.description ?? '');

  useEffect(() => {
    if (onChange) {
      onChange({ name, description });
    }
  }, [name, description]);

  return (
    <Card variant='secondary'>
      <ThemeInput
        caption='Feature-Bezeichnung'
        value={name}
        onChange={e => setName(e.target.value)}
        placeholder='Wie lautet der Name Deines Features?'
      />
      <ThemeTextArea
        caption='Feature-Beschreibung'
        value={description}
        onChange={e => setDescription(e.target.value)}
        placeholder='z.B. Als User möchte ich eine Suchfunktion nutzen können, um schnell meinen gewünschten Artikel zu finden.'
      />
    </Card>
  );
};

const Card = styled(ThemeCard)`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.xl};
  padding: ${theme.spacing.l};
  width: 100%;
  flex: 1;

  @media screen and (max-width: ${theme.responsive.breakpoints.medium}) {
    padding: ${theme.spacing.d};
  }
`;
